import { FaqDrawerConstants } from '@src/apps/constants/faq-drawer';
import { ChevronRight } from '@src/Assets/svg/ChevronRight';
import React from 'react';

interface FooterSectionProps {
  onContactUs?: () => void;
}

export const FooterSection: React.FC<FooterSectionProps> = ({ onContactUs }) => {
  return (
    <div className="contact-us-section">
      <div className="more-questions-title">{FaqDrawerConstants.moreQuestions}</div>
      <div className="contact-us-row" onClick={onContactUs}>
        <span className="contact-us-text">{FaqDrawerConstants.contactUs} <ChevronRight /></span>
      </div>
    </div>
  );
};
